import React from 'react';

const LogoHeader = ({ name = 'logo', slug = '/' }: LogoProps) => {
  return (
    <a href={slug}>
      <span className={'sr-only'}>{name}</span>
      <svg
        width="53"
        height="53"
        viewBox="0 0 53 53"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.5 0V13.2968C27.5099 13.3155 28.5385 13.4651 29.567 13.7269C36.6175 15.6157 40.8066 22.8719 38.9178 29.9224C37.0289 36.9728 29.7728 41.162 22.7223 39.2731C15.6718 37.3843 11.4827 30.1281 13.3716 23.0776C13.8204 21.3945 14.5872 19.8797 15.5783 18.5706L5.0681 10.9217C1.62703 15.6531 0 20.6464 0 26.5C0 41.1433 11.8754 53 26.5 53C41.1246 53 53 41.1246 53 26.5C53.0187 11.8754 41.1433 0 26.5 0Z"
          fill="#F7A823"
        />
      </svg>
    </a>
  );
};

export type LogoProps = {
  isLight?: boolean;
  name?: string;
  slug?: string;
  locale?: string;
};

export default LogoHeader;
